import CloseIcon from '@/assets/icons/close-x.svg?react';
import styles from './EditableTile.module.scss';

interface IEditableTileProps {
  label?: string;
  value: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (newValue: string) => void;
  onBlur?: () => void;
  type?: 'tile' | 'rectangle';
  variant?: 'normal' | 'large' | 'extra' | 'xxl' | 'fullWidth';
  alignment?: 'left' | 'center' | 'right';
  className?: string;
  maxLength?: number;
}

function EditableTile({ label, value, onChange, onBlur, type = 'tile', variant = 'normal', alignment = 'center', className = '', maxLength }: IEditableTileProps) {
  return (
    <div className={`${styles.editableTile} ${styles[type]} ${styles[variant]} ${className}`}>
      {label && <div className={styles.label}>{label}</div>}
      {type === 'rectangle' && <CloseIcon className={styles.clearIcon} onClick={() => onChange('')} />}
      <input type="text" value={value} autoComplete="off" onChange={(e) => onChange(e.target.value)} onBlur={onBlur} className={styles[alignment]} maxLength={maxLength} />
    </div>
  );
}

export default EditableTile;
